import React from "react";
import {RotateCcw} from "lucide-react";
import Button from "@components/Button/Button";

import "./ChunkErrorFallback.css";

// Route-level error fallback; pass it as `fallback={ChunkErrorFallback}` so Sentry hands it the error.
// The common case is a route's lazy() chunk failing to load: a deploy landed while a tab was open,
// the old index references hashed chunks that no longer exist, and the import 404s. A reload
// fetches the new index and fixes it. Any other render error gets a generic line instead.
// ponytail: a reload button, not auto-retry — retrying a 404 just fails again.

const CHUNK_ERROR = /dynamically imported module|Importing a module script failed|Unable to preload CSS/i;

export const isChunkError = (error) => CHUNK_ERROR.test(error?.message ?? "");

const ChunkErrorFallback = ({error} = {}) => (
    <div className="chunk-error">
        <div className="chunk-error-card" role="alert">
            <h2 className="chunk-error-title">This page failed to load</h2>
            <p className="chunk-error-text">
                {isChunkError(error)
                    ? "The app was likely updated since you opened this tab."
                    : "Something went wrong. Try reloading; if it keeps happening, contact support."}
            </p>
            <Button
                variant="primary"
                size="md"
                icon={<RotateCcw size={15}/>}
                onClick={() => window.location.reload()}
            >
                Reload Page
            </Button>
        </div>
    </div>
);

export default ChunkErrorFallback;
